import {
  createBrowserRouter,
  createRoutesFromElements,
  HashRouter,
  Route,
  RouterProvider,
  Routes,
} from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { createTheme, CssBaseline } from "@mui/material";

/* Layouts */
import RootLayout from "./Layouts/Root/RootLayout";

/* Pages */
import HomePage from "./Pages/Home/HomePage";

function App() {
  const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        hs: 365,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        xxl: 1536,
      },
    },
    palette: {
      primary: {
        light: "#fa5a77",
        main: "#db3755",
        dark: "#8a1321",
        contrastText: "#fff",
      },
      secondary: {
        light: "#ff7961",
        main: "#f44336",
        dark: "#ba000d",
        contrastText: "#000",
      },
      white: {
        light: "#fff",
        main: "#fff",
        dark: "#333333",
        contrastText: "#000",
      },
    },
  });

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/">
        <Route path="/" element={<RootLayout />}>
          <Route index element={<HomePage />} />
        </Route>
      </Route>
    )
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <HashRouter>
        <Routes>
          <Route path="/" element={<RootLayout />}>
            <Route index element={<HomePage />} />
          </Route>
        </Routes>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
